import { useCallback } from 'react';
import { useToast } from '../context/ToastContext';

/**
 * Returns a stable `copyToClipboard(value, label)` function that writes
 * `value` to the clipboard and shows a toast on success or failure.
 *
 * @param value - The string to copy.
 * @param label - A human-readable name for what is being copied, used in
 *   toast messages, e.g. "Collection ID" → "Collection ID copied to clipboard!"
 */
export function useCopyToClipboard() {
  const { showToast } = useToast();

  const copyToClipboard = useCallback(
    async (value: string, label: string) => {
      try {
        await navigator.clipboard.writeText(value);
        showToast(`${label} copied to clipboard!`, 'success');
      } catch (error) {
        console.error('Failed to copy to clipboard', { label, value, error });
        showToast(`Failed to copy ${label}. Please try again.`, 'error');
      }
    },
    [showToast],
  );

  return { copyToClipboard };
}
